import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.jsx";
import "./index.css";
import ConfigService from "./services/ConfigService";
import ElectronService from "./services/ElectronService";
import EventsService from "./services/EventsService";
import Telemetry from "@poriyaalar/telemetry";

// scroll bar
import "simplebar/src/simplebar.css";

import { get, isEmpty } from "lodash";
import { HelmetProvider } from "react-helmet-async";
import { isValidUUID } from "./utils/isValidUUID.js";

if (import.meta.env.VITE_APP_ENV === "production") {
  const TelemetryService = new Telemetry({
    sentry: {
      dsn: "https://d74563c4b3d3862f29e8f45a616c6729@o4507809692712960.ingest.de.sentry.io/4508883718242384",
      environment: import.meta.env.VITE_APP_ENV,
      tracePropagationTargets: [/^https:\/\/public\.positeasy\.in\//],
      tracesSampleRate: 0,
    },
  });
  window.telemetry = TelemetryService;
}
const PATH_ARRAY = window.location.pathname.split("/");
if (window.mainAPI) {
  console.log = (args, data) => {
    window.mainAPI.log("log", { args, data });
  };
}
function validateMerchantId(merchantId, storeId) {
  return new Promise((resolve, reject) => {
    if (!merchantId || !storeId) {
      resolve(false);
      return;
    }
    fetch(
      `${
        import.meta.env.VITE_REMOTE_URL
      }/api/v1/POS/merchant/on-table/otherDetails?merchantId=${merchantId}&storeId=${storeId}`
    )
      .then((res) => res.json())
      .then((data) => {
        if (!isEmpty(data)) {
          sessionStorage.setItem("storeDetails", JSON.stringify(data));
          resolve(true);
        } else {
          resolve(false);
        }
      })
      .catch((err) => {
        console.log(err);
        resolve(false);
      });
  });
}

function bootApp() {
  console.log(PATH_ARRAY, "APAARH ARRAYY");
  const localPaymentId = JSON.parse(
    sessionStorage.getItem("trackOrder") || "{}"
  );
  const isTrackingPage = get(localPaymentId, "paymentId", false);

  const isTable = isValidUUID(PATH_ARRAY[3]);
  const subPath = isTrackingPage
    ? `/${isTrackingPage}`
    : isEmpty(localMerchantDetails)
    ? isTable
      ? `/${PATH_ARRAY[1]}/${PATH_ARRAY[2]}/${PATH_ARRAY[3]}`
      : `/${PATH_ARRAY[1]}/${PATH_ARRAY[2]}`
    : isTable
    ? `/${get(JSON.parse(localMerchantDetails), "merchantId")}/${get(
        JSON.parse(localMerchantDetails),
        "storeId"
      )}/${get(JSON.parse(localMerchantDetails), "tableId")}`
    : `/${get(JSON.parse(localMerchantDetails), "merchantId")}/${get(
        JSON.parse(localMerchantDetails),
        "storeId"
      )}`;
  console.log(subPath, "SUSUUB");
  EventsService.boot(() => {
    ConfigService.boot(() => {
      ReactDOM.createRoot(document.getElementById("root")).render(
        <React.StrictMode>
          <HelmetProvider>
            <BrowserRouter basename={subPath}>
              <App />
            </BrowserRouter>
          </HelmetProvider>
        </React.StrictMode>
      );
    });
  });
  window.ElectronService = ElectronService;
}
function bootAppForRajalakshmi(merchantId, storeId, tabldId = false) {
  const subPath = tabldId
    ? `/${merchantId}/${storeId}/${tabldId}`
    : `/${merchantId}/${storeId}`;
  console.log(subPath, "MERCHATN STORE");
  console.log(tabldId, "TABBLLEEEE");

  EventsService.boot(() => {
    ConfigService.boot(() => {
      ReactDOM.createRoot(document.getElementById("root")).render(
        <React.StrictMode>
          <HelmetProvider>
            <BrowserRouter basename={subPath}>
              <App />
            </BrowserRouter>
          </HelmetProvider>
        </React.StrictMode>
      );
    });
  });
  window.ElectronService = ElectronService;
}

function renderErrorPage() {
  document.getElementById("loading").innerText = "Invalid Merchant ID";
}
function renderTransactionError() {
  document.getElementById("loading").innerText = "Invalid Transaction";
}
// ----------------------------------------------------------------------

// verification of merchantId and storeId

const localMerchantDetails = sessionStorage.getItem("merchantDetails");
const urlParams = new URLSearchParams(window.location.search);
const myParam = urlParams.get("tableId");
console.log(window.location.pathname, "PARRRAMS");
console.log(PATH_ARRAY, "PAATHH RARRRA");
if (window.location.pathname === "/track/order") {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const urlParamsData = {};
  for (const [key, value] of urlParams.entries()) {
    urlParamsData[key] = value;
  }
  window.urlParamsData = urlParamsData;
  const paymentId = get(urlParamsData, "paymentId");
  console.log("iraannn");
  if (paymentId) {
    sessionStorage.setItem("trackOrder", JSON.stringify({ paymentId }));
    window.location.href = `/${paymentId}/track/order`;
    bootApp();
    document.getElementById("loading").style.display = "none";
  } else {
    renderTransactionError();
  }
} else if (window.location.pathname.includes("/track/order")) {
  const paymentId = PATH_ARRAY[1];
  if (paymentId) {
    sessionStorage.setItem("trackOrder", JSON.stringify({ paymentId }));
    bootApp();
    document.getElementById("loading").style.display = "none";
  } else {
    renderTransactionError();
  }
} else if (window.location.pathname === "/") {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const urlParamsData = {};
  for (const [key, value] of urlParams.entries()) {
    urlParamsData[key] = value;
  }
  const currentUrl = window.location.href;
  window.urlParamsData = urlParamsData;
  console.log(currentUrl, "CCCCCC");

  if (currentUrl === "https://rajalakshmiengg.positeasy.in/") {
    console.log("urlParamsData", currentUrl);
    const merchantId = "9648af36-db50-4e16-89fc-4741e62ae448";
    const storeId = "Store1s";
    const type = get(urlParamsData, "type");
    const tableId = get(urlParamsData, "tableId");
    validateMerchantId(merchantId, storeId)
      .then((isValid) => {
        console.log(isValid, "ISSVALIDD");
        if (isValid) {
          document.getElementById("loading").style.display = "none";
          sessionStorage.setItem(
            "merchantDetails",
            JSON.stringify({ merchantId, storeId, type, tableId })
          );
          if (tableId) {
            bootAppForRajalakshmi(merchantId, storeId, tableId);
          } else {
            console.log("iraan");
            bootAppForRajalakshmi(merchantId, storeId);
          }
          window.location.href = tableId
            ? `/${merchantId}/${storeId}/${tableId}`
            : `/${merchantId}/${storeId}`;
        } else {
          renderErrorPage();
        }
      })
      .catch((err) => {
        console.log("error", err);
        renderErrorPage();
      });
  } else if (currentUrl === "https://app.kodo.co.in/") {
    console.log("urlParamsData", currentUrl);
    const merchantId = "21fc782e-ffe4-4a9f-9f49-32701a5aef5a";
    const storeId = "Store1s";
    const type = get(urlParamsData, "type");
    const tableId = get(urlParamsData, "tableId");
    validateMerchantId(merchantId, storeId)
      .then((isValid) => {
        if (isValid) {
          document.getElementById("loading").style.display = "none";
          sessionStorage.setItem(
            "merchantDetails",
            JSON.stringify({ merchantId, storeId, type, tableId })
          );
          if (tableId) {
            bootAppForRajalakshmi(merchantId, storeId, tableId);
          } else {
            console.log("iraan");
            bootAppForRajalakshmi(merchantId, storeId);
          }
          window.location.href = tableId
            ? `/${merchantId}/${storeId}/${tableId}`
            : `/${merchantId}/${storeId}`;
        } else {
          renderErrorPage();
        }
      })
      .catch((err) => {
        console.log("error", err);
        renderErrorPage();
      });
  } else {
    const emptyurl = isEmpty(urlParamsData);
    const merchantId = get(
      emptyurl ? JSON.parse(localMerchantDetails) : urlParamsData,
      "merchantId"
    );
    const storeId = get(
      emptyurl ? JSON.parse(localMerchantDetails) : urlParamsData,
      "storeId"
    );

    const type = get(urlParamsData, "type");
    const tableId = get(urlParamsData, "tableId");
    validateMerchantId(merchantId, storeId)
      .then((isValid) => {
        if (isValid) {
          document.getElementById("loading").style.display = "none";
          sessionStorage.setItem(
            "merchantDetails",
            JSON.stringify({ merchantId, storeId, type, tableId })
          );
          bootApp();
          console.log(tableId, type, "TAABLE");
          window.location.href = tableId
            ? `/${merchantId}/${storeId}/${tableId}`
            : `/${merchantId}/${storeId}`;
        } else {
          renderErrorPage();
        }
      })
      .catch((err) => {
        renderErrorPage();
      });
  }
} else if (
  window.location.pathname !== "/" &&
  (!isEmpty(localMerchantDetails) ||
    !isEmpty(PATH_ARRAY[1]) ||
    !isEmpty(PATH_ARRAY[2]))
) {
  if (isEmpty(localMerchantDetails)) {
    sessionStorage.setItem(
      "merchantDetails",
      JSON.stringify({
        merchantId: PATH_ARRAY[1],
        storeId: PATH_ARRAY[2],
        ...(isValidUUID(PATH_ARRAY[3]) && { tableId: PATH_ARRAY[3] }),
      })
    );
  }
  bootApp();
  document.getElementById("loading").style.display = "none";
} else {
  renderErrorPage();
}
